import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Sign In / Create Account switcher shown at the top of both auth cards.
// The pill starts on the opposite tab and slides across on mount, so switching
// routes feels like one screen changing tabs.
export default function AuthTabs({ active }) {
  const next = new URLSearchParams(window.location.search).get("next");
  const query = next ? `?next=${encodeURIComponent(next)}` : "";
  const [pos, setPos] = useState(active === "login" ? "register" : "login");

  useEffect(() => {
    const id = requestAnimationFrame(() => setPos(active));
    return () => cancelAnimationFrame(id);
  }, [active]);

  const tab = (key, label, to) => (
    <Link
      to={to}
      replace
      aria-current={active === key ? "page" : undefined}
      className={`relative z-10 flex-1 flex items-center justify-center h-10 rounded-full text-sm font-semibold transition-colors duration-300 ${active === key ? "text-white" : "text-[#1A2744] hover:opacity-70"}`}
    >
      {label}
    </Link>
  );

  return (
    <div className="relative flex p-1 mb-6 bg-gray-100 rounded-full animate-fade-up [animation-delay:150ms]">
      <span
        aria-hidden="true"
        className={`absolute top-1 bottom-1 left-1 w-[calc(50%-4px)] rounded-full bg-[#1A2744] shadow transition-transform duration-500 ease-out ${pos === "register" ? "translate-x-full" : "translate-x-0"}`}
      />
      {tab("login", "Sign In", `/login${query}`)}
      {tab("register", "Create Account", `/Register${query}`)}
    </div>
  );
}